import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Seo } from "@/lib/seo";
import { api, mediaUrl } from "@/lib/api";
import { QuoteButton } from "@/components/QuoteButton";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(null));
  }, [slug]);

  if (post === undefined) return <div className="min-h-screen pt-40 text-center text-[#2C2C2C]/60">Chargement…</div>;
  if (post === null) return (
    <div className="min-h-screen pt-40 text-center">
      <p className="text-[#2C2C2C]/60">Article introuvable.</p>
      <Link to="/blog" className="mt-4 inline-block text-[#C9A84C]">Retour au Journal</Link>
    </div>
  );

  return (
    <article className="min-h-screen bg-[#FAF6EF] pt-28" data-testid="blog-post-page">
      <Seo title={`${post.title} — Le Journal Afro Regal`} description={post.excerpt} />
      <div className="mx-auto max-w-3xl px-5 py-14 lg:px-8">
        <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-[#2C2C2C]/60 hover:text-[#C9A84C]"><ChevronLeft size={16} /> Le Journal</Link>
        <h1 className="mt-6 font-serif text-4xl font-500 leading-tight text-[#2C2C2C] lg:text-5xl">{post.title}</h1>
        {post.cover_url && <img src={mediaUrl(post.cover_url)} alt={post.title} className="mt-8 w-full rounded-2xl object-cover" />}
        <div className="prose mt-8 max-w-none whitespace-pre-wrap text-base leading-relaxed text-[#2C2C2C]/80">{post.content}</div>
        <div className="mt-12 rounded-2xl border border-[#2C2C2C]/10 bg-white p-8 text-center">
          <p className="font-serif text-2xl text-[#2C2C2C]">Un projet d'événement ?</p>
          <div className="mt-5 flex justify-center"><QuoteButton testId="blogpost-quote" /></div>
        </div>
      </div>
    </article>
  );
}
